var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "course-icon",
      attrs: { "data-size": _vm.size, "data-value": this.value },
    },
    [
      _vm.existingIllustrations.includes(this.value)
        ? _c(
            "svg",
            {
              attrs: {
                width: "43",
                height: "26",
                viewBox: "0 0 43 26",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              this.value === "us" || this.value === "en"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M40.7324 2H18V4H41V3C41 2.63571 40.9026 2.29417 40.7324 2Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 8H41V6H18V8Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 12H41V10H18V12Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 16H41V14H1V16Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 20H41V18H1V20Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M1.26756 24C1.09739 23.7058 1 23.3643 1 23V22H41V23C41 23.3643 40.9026 23.7058 40.7324 24H1.26756Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 14H18.0001V1H3C1.89543 1 1 1.89543 1 3V14Z",
                        fill: "#3C3B6E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 9.92925H16.93L16.75 9.375L16.5783 9.92925H16L16.4635 10.2862L16.273 10.875L16.7523 10.5067L17.2218 10.869L17.0335 10.2862L17.5 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 11.2418H15.4803L15.3003 10.6875L15.1285 11.2418H14.5503L15.0138 11.5987L14.8233 12.1875L15.3025 11.8192L15.772 12.1815L15.5838 11.5987L16.0503 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 8.61675H15.4803L15.3003 8.0625L15.1285 8.61675H14.5503L15.0138 8.97375L14.8233 9.5625L15.3025 9.19425L15.772 9.5565L15.5838 8.97375L16.0503 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 5.99175H15.4803L15.3003 5.4375L15.1285 5.99175H14.5503L15.0138 6.34875L14.8233 6.9375L15.3025 6.56925L15.772 6.9315L15.5838 6.34875L16.0503 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 3.36675H15.4803L15.3003 2.8125L15.1285 3.36675H14.5503L15.0138 3.72375L14.8233 4.3125L15.3025 3.94425L15.772 4.3065L15.5838 3.72375L16.0503 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 11.2418H12.5799L12.3999 10.6875L12.2282 11.2418H11.6499L12.1134 11.5987L11.9229 12.1875L12.4022 11.8192L12.8717 12.1815L12.6834 11.5987L13.1499 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 8.61675H12.5799L12.3999 8.0625L12.2282 8.61675H11.6499L12.1134 8.97375L11.9229 9.5625L12.4022 9.19425L12.8717 9.5565L12.6834 8.97375L13.1499 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 5.99175H12.5799L12.3999 5.4375L12.2282 5.99175H11.6499L12.1134 6.34875L11.9229 6.9375L12.4022 6.56925L12.8717 6.9315L12.6834 6.34875L13.1499 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 3.36675H12.5799L12.3999 2.8125L12.2282 3.36675H11.6499L12.1134 3.72375L11.9229 4.3125L12.4022 3.94425L12.8717 4.3065L12.6834 3.72375L13.1499 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 11.2418H9.68L9.5 10.6875L9.32825 11.2418H8.75L9.2135 11.5987L9.023 12.1875L9.50225 11.8192L9.97175 12.1815L9.7835 11.5987L10.25 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 8.61675H9.68L9.5 8.0625L9.32825 8.61675H8.75L9.2135 8.97375L9.023 9.5625L9.50225 9.19425L9.97175 9.5565L9.7835 8.97375L10.25 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 5.99175H9.68L9.5 5.4375L9.32825 5.99175H8.75L9.2135 6.34875L9.023 6.9375L9.50225 6.56925L9.97175 6.9315L9.7835 6.34875L10.25 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 3.36675H9.68L9.5 2.8125L9.32825 3.36675H8.75L9.2135 3.72375L9.023 4.3125L9.50225 3.94425L9.97175 4.3065L9.7835 3.72375L10.25 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 11.2418H6.7801L6.6001 10.6875L6.42835 11.2418H5.8501L6.3136 11.5987L6.1231 12.1875L6.60235 11.8192L7.07185 12.1815L6.8836 11.5987L7.3501 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 8.61675H6.7801L6.6001 8.0625L6.42835 8.61675H5.8501L6.3136 8.97375L6.1231 9.5625L6.60235 9.19425L7.07185 9.5565L6.8836 8.97375L7.3501 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 5.99175H6.7801L6.6001 5.4375L6.42835 5.99175H5.8501L6.3136 6.34875L6.1231 6.9375L6.60235 6.56925L7.07185 6.9315L6.8836 6.34875L7.3501 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 3.36675H6.7801L6.6001 2.8125L6.42835 3.36675H5.8501L6.3136 3.72375L6.1231 4.3125L6.60235 3.94425L7.07185 4.3065L6.8836 3.72375L7.3501 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 11.2418H3.8802L3.7002 10.6875L3.52845 11.2418H2.9502L3.4137 11.5987L3.2232 12.1875L3.70245 11.8192L4.17195 12.1815L3.9837 11.5987L4.4502 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 8.61675H3.8802L3.7002 8.0625L3.52845 8.61675H2.9502L3.4137 8.97375L3.2232 9.5625L3.70245 9.19425L4.17195 9.5565L3.9837 8.97375L4.4502 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 5.99175H3.8802L3.7002 5.4375L3.52845 5.99175H2.9502L3.4137 6.34875L3.2232 6.9375L3.70245 6.56925L4.17195 6.9315L3.9837 6.34875L4.4502 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 3.36675H3.8802L3.7002 2.8125L3.52845 3.36675H2.9502L3.4137 3.72375L3.2232 4.3125L3.70245 3.94425L4.17195 4.3065L3.9837 3.72375L4.4502 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 12.5543H16.93L16.75 12L16.5783 12.5543H16L16.4635 12.9112L16.273 13.5L16.7523 13.1317L17.2218 13.494L17.0335 12.9112L17.5 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 12.5543H14.0301L13.8501 12L13.6783 12.5543H13.1001L13.5636 12.9112L13.3731 13.5L13.8523 13.1317L14.3218 13.494L14.1336 12.9112L14.6001 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 9.92925H14.0301L13.8501 9.375L13.6783 9.92925H13.1001L13.5636 10.2862L13.3731 10.875L13.8523 10.5067L14.3218 10.869L14.1336 10.2862L14.6001 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 7.30425H14.0301L13.8501 6.75L13.6783 7.30425H13.1001L13.5636 7.66125L13.3731 8.25L13.8523 7.88175L14.3218 8.244L14.1336 7.66125L14.6001 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 4.67925H14.0301L13.8501 4.125L13.6783 4.67925H13.1001L13.5636 5.03625L13.3731 5.625L13.8523 5.25675L14.3218 5.619L14.1336 5.03625L14.6001 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 2.05425H14.0301L13.8501 1.5L13.6783 2.05425H13.1001L13.5636 2.41125L13.3731 3L13.8523 2.63175L14.3218 2.994L14.1336 2.41125L14.6001 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 12.5543H11.1302L10.9502 12L10.7784 12.5543H10.2002L10.6637 12.9112L10.4732 13.5L10.9524 13.1317L11.4219 13.494L11.2337 12.9112L11.7002 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 9.92925H11.1302L10.9502 9.375L10.7784 9.92925H10.2002L10.6637 10.2862L10.4732 10.875L10.9524 10.5067L11.4219 10.869L11.2337 10.2862L11.7002 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 7.30425H11.1302L10.9502 6.75L10.7784 7.30425H10.2002L10.6637 7.66125L10.4732 8.25L10.9524 7.88175L11.4219 8.244L11.2337 7.66125L11.7002 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 4.67925H11.1302L10.9502 4.125L10.7784 4.67925H10.2002L10.6637 5.03625L10.4732 5.625L10.9524 5.25675L11.4219 5.619L11.2337 5.03625L11.7002 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 2.05425H11.1302L10.9502 1.5L10.7784 2.05425H10.2002L10.6637 2.41125L10.4732 3L10.9524 2.63175L11.4219 2.994L11.2337 2.41125L11.7002 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 12.5543H8.23029L8.05029 12L7.87854 12.5543H7.30029L7.76379 12.9112L7.57329 13.5L8.05254 13.1317L8.52204 13.494L8.33379 12.9112L8.80029 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 9.92925H8.23029L8.05029 9.375L7.87854 9.92925H7.30029L7.76379 10.2862L7.57329 10.875L8.05254 10.5067L8.52204 10.869L8.33379 10.2862L8.80029 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 7.30425H8.23029L8.05029 6.75L7.87854 7.30425H7.30029L7.76379 7.66125L7.57329 8.25L8.05254 7.88175L8.52204 8.244L8.33379 7.66125L8.80029 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 4.67925H8.23029L8.05029 4.125L7.87854 4.67925H7.30029L7.76379 5.03625L7.57329 5.625L8.05254 5.25675L8.52204 5.619L8.33379 5.03625L8.80029 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 2.05425H8.23029L8.05029 1.5L7.87854 2.05425H7.30029L7.76379 2.41125L7.57329 3L8.05254 2.63175L8.52204 2.994L8.33379 2.41125L8.80029 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 12.5543H5.3299L5.1499 12L4.97815 12.5543H4.3999L4.8634 12.9112L4.6729 13.5L5.15215 13.1317L5.62165 13.494L5.4334 12.9112L5.8999 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 9.92925H5.3299L5.1499 9.375L4.97815 9.92925H4.3999L4.8634 10.2862L4.6729 10.875L5.15215 10.5067L5.62165 10.869L5.4334 10.2862L5.8999 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 7.30425H5.3299L5.1499 6.75L4.97815 7.30425H4.3999L4.8634 7.66125L4.6729 8.25L5.15215 7.88175L5.62165 8.244L5.4334 7.66125L5.8999 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 4.67925H5.3299L5.1499 4.125L4.97815 4.67925H4.3999L4.8634 5.03625L4.6729 5.625L5.15215 5.25675L5.62165 5.619L5.4334 5.03625L5.8999 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 2.05425H5.3299L5.1499 1.5L4.97815 2.05425H4.3999L4.8634 2.41125L4.6729 3L5.15215 2.63175L5.62165 2.994L5.4334 2.41125L5.8999 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 12.5543H2.43L2.25 12L2.07825 12.5543H1.5L1.9635 12.9112L1.773 13.5L2.25225 13.1317L2.72175 13.494L2.5335 12.9112L3 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 9.92925H2.43L2.25 9.375L2.07825 9.92925H1.5L1.9635 10.2862L1.773 10.875L2.25225 10.5067L2.72175 10.869L2.5335 10.2862L3 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 7.30425H2.43L2.25 6.75L2.07825 7.30425H1.5L1.9635 7.66125L1.773 8.25L2.25225 7.88175L2.72175 8.244L2.5335 7.66125L3 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 4.67925H2.43L2.25 4.125L2.07825 4.67925H1.5L1.9635 5.03625L1.773 5.625L2.25225 5.25675L2.72175 5.619L2.5335 5.03625L3 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 2.05425H2.43L2.25 1.5L2.07825 2.05425H1.5L1.9635 2.41125L1.773 3L2.25225 2.63175L2.72175 2.994L2.5335 2.41125L3 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 7.30425H16.93L16.75 6.75L16.5783 7.30425H16L16.4635 7.66125L16.273 8.25L16.7523 7.88175L17.2218 8.244L17.0335 7.66125L17.5 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 4.67925H16.93L16.75 4.125L16.5783 4.67925H16L16.4635 5.03625L16.273 5.625L16.7523 5.25675L17.2218 5.619L17.0335 5.03625L17.5 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 2.05425H16.93L16.75 1.5L16.5783 2.05425H16L16.4635 2.41125L16.273 3L16.7523 2.63175L17.2218 2.994L17.0335 2.41125L17.5 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "gb"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H9L1 4V9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 1L17 8V1H6Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17V22L9 17H1Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 25H17V18L6 25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33.0005 17L41.0005 22V17H33.0005Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 25H36L25 18V25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33 9H41V4L33 9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 1V8L36 1H25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M1.02783 2.66425L10.4118 8.99997H12.9998L1.70862 1.47253C1.35604 1.77087 1.10815 2.18908 1.02783 2.66425Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M3.61734 25L16.0003 17H13.2823L1.71631 24.5336C2.06369 24.8247 2.51142 25 3.0001 25H3.61734Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M40.9645 23.3773L31 17H28L40.2661 24.5483C40.6215 24.2573 40.8749 23.8464 40.9645 23.3773Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M38.4331 1L26 9H28.6609L40.2824 1.46522C39.9353 1.17481 39.488 1 39 1H38.4331Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 1V10H1V16H18V25H24V16H40.999V10H24V1H18Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "us-gb"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M39 25C40.1046 25 41 24.1046 41 23V2.6C41 1.71634 40.2837 1 39.4001 1H3C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 25H17V18L6 25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33.0005 17L41.0005 22V17H33.0005Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M25 25H36L25 18V25Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M33 9H41V4L33 9Z",
                        fill: "#00247D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M40.9645 23.3773L31 17H28L40.2661 24.5484C40.6215 24.2574 40.875 23.8464 40.9645 23.3773Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 14H18.0001V1H3C1.89543 1 1 1.89543 1 3V14Z",
                        fill: "#3C3B6E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 9.92925H16.93L16.75 9.375L16.5783 9.92925H16L16.4635 10.2862L16.273 10.875L16.7523 10.5067L17.2218 10.869L17.0335 10.2862L17.5 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 11.2418H15.4803L15.3003 10.6875L15.1285 11.2418H14.5503L15.0138 11.5987L14.8233 12.1875L15.3025 11.8192L15.772 12.1815L15.5838 11.5987L16.0503 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 8.61675H15.4803L15.3003 8.0625L15.1285 8.61675H14.5503L15.0138 8.97375L14.8233 9.5625L15.3025 9.19425L15.772 9.5565L15.5838 8.97375L16.0503 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 5.99175H15.4803L15.3003 5.4375L15.1285 5.99175H14.5503L15.0138 6.34875L14.8233 6.9375L15.3025 6.56925L15.772 6.9315L15.5838 6.34875L16.0503 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16.0503 3.36675H15.4803L15.3003 2.8125L15.1285 3.36675H14.5503L15.0138 3.72375L14.8233 4.3125L15.3025 3.94425L15.772 4.3065L15.5838 3.72375L16.0503 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 11.2418H12.5799L12.3999 10.6875L12.2282 11.2418H11.6499L12.1134 11.5987L11.9229 12.1875L12.4022 11.8192L12.8717 12.1815L12.6834 11.5987L13.1499 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 8.61675H12.5799L12.3999 8.0625L12.2282 8.61675H11.6499L12.1134 8.97375L11.9229 9.5625L12.4022 9.19425L12.8717 9.5565L12.6834 8.97375L13.1499 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 5.99175H12.5799L12.3999 5.4375L12.2282 5.99175H11.6499L12.1134 6.34875L11.9229 6.9375L12.4022 6.56925L12.8717 6.9315L12.6834 6.34875L13.1499 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.1499 3.36675H12.5799L12.3999 2.8125L12.2282 3.36675H11.6499L12.1134 3.72375L11.9229 4.3125L12.4022 3.94425L12.8717 4.3065L12.6834 3.72375L13.1499 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 11.2418H9.68L9.5 10.6875L9.32825 11.2418H8.75L9.2135 11.5987L9.023 12.1875L9.50225 11.8192L9.97175 12.1815L9.7835 11.5987L10.25 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 8.61675H9.68L9.5 8.0625L9.32825 8.61675H8.75L9.2135 8.97375L9.023 9.5625L9.50225 9.19425L9.97175 9.5565L9.7835 8.97375L10.25 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 5.99175H9.68L9.5 5.4375L9.32825 5.99175H8.75L9.2135 6.34875L9.023 6.9375L9.50225 6.56925L9.97175 6.9315L9.7835 6.34875L10.25 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.25 3.36675H9.68L9.5 2.8125L9.32825 3.36675H8.75L9.2135 3.72375L9.023 4.3125L9.50225 3.94425L9.97175 4.3065L9.7835 3.72375L10.25 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 11.2418H6.7801L6.6001 10.6875L6.42835 11.2418H5.8501L6.3136 11.5987L6.1231 12.1875L6.60235 11.8192L7.07185 12.1815L6.8836 11.5987L7.3501 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 8.61675H6.7801L6.6001 8.0625L6.42835 8.61675H5.8501L6.3136 8.97375L6.1231 9.5625L6.60235 9.19425L7.07185 9.5565L6.8836 8.97375L7.3501 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 5.99175H6.7801L6.6001 5.4375L6.42835 5.99175H5.8501L6.3136 6.34875L6.1231 6.9375L6.60235 6.56925L7.07185 6.9315L6.8836 6.34875L7.3501 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.3501 3.36675H6.7801L6.6001 2.8125L6.42835 3.36675H5.8501L6.3136 3.72375L6.1231 4.3125L6.60235 3.94425L7.07185 4.3065L6.8836 3.72375L7.3501 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 11.2418H3.8802L3.7002 10.6875L3.52845 11.2418H2.9502L3.4137 11.5987L3.2232 12.1875L3.70245 11.8192L4.17195 12.1815L3.9837 11.5987L4.4502 11.2418Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 8.61675H3.8802L3.7002 8.0625L3.52845 8.61675H2.9502L3.4137 8.97375L3.2232 9.5625L3.70245 9.19425L4.17195 9.5565L3.9837 8.97375L4.4502 8.61675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 5.99175H3.8802L3.7002 5.4375L3.52845 5.99175H2.9502L3.4137 6.34875L3.2232 6.9375L3.70245 6.56925L4.17195 6.9315L3.9837 6.34875L4.4502 5.99175Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M4.4502 3.36675H3.8802L3.7002 2.8125L3.52845 3.36675H2.9502L3.4137 3.72375L3.2232 4.3125L3.70245 3.94425L4.17195 4.3065L3.9837 3.72375L4.4502 3.36675Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 12.5543H16.93L16.75 12L16.5783 12.5543H16L16.4635 12.9112L16.273 13.5L16.7523 13.1317L17.2218 13.494L17.0335 12.9112L17.5 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 12.5543H14.0301L13.8501 12L13.6783 12.5543H13.1001L13.5636 12.9112L13.3731 13.5L13.8523 13.1317L14.3218 13.494L14.1336 12.9112L14.6001 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 9.92925H14.0301L13.8501 9.375L13.6783 9.92925H13.1001L13.5636 10.2862L13.3731 10.875L13.8523 10.5067L14.3218 10.869L14.1336 10.2862L14.6001 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 7.30425H14.0301L13.8501 6.75L13.6783 7.30425H13.1001L13.5636 7.66125L13.3731 8.25L13.8523 7.88175L14.3218 8.244L14.1336 7.66125L14.6001 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 4.67925H14.0301L13.8501 4.125L13.6783 4.67925H13.1001L13.5636 5.03625L13.3731 5.625L13.8523 5.25675L14.3218 5.619L14.1336 5.03625L14.6001 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6001 2.05425H14.0301L13.8501 1.5L13.6783 2.05425H13.1001L13.5636 2.41125L13.3731 3L13.8523 2.63175L14.3218 2.994L14.1336 2.41125L14.6001 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 12.5543H11.1302L10.9502 12L10.7784 12.5543H10.2002L10.6637 12.9112L10.4732 13.5L10.9524 13.1317L11.4219 13.494L11.2337 12.9112L11.7002 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 9.92925H11.1302L10.9502 9.375L10.7784 9.92925H10.2002L10.6637 10.2862L10.4732 10.875L10.9524 10.5067L11.4219 10.869L11.2337 10.2862L11.7002 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 7.30425H11.1302L10.9502 6.75L10.7784 7.30425H10.2002L10.6637 7.66125L10.4732 8.25L10.9524 7.88175L11.4219 8.244L11.2337 7.66125L11.7002 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 4.67925H11.1302L10.9502 4.125L10.7784 4.67925H10.2002L10.6637 5.03625L10.4732 5.625L10.9524 5.25675L11.4219 5.619L11.2337 5.03625L11.7002 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.7002 2.05425H11.1302L10.9502 1.5L10.7784 2.05425H10.2002L10.6637 2.41125L10.4732 3L10.9524 2.63175L11.4219 2.994L11.2337 2.41125L11.7002 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 12.5543H8.23029L8.05029 12L7.87854 12.5543H7.30029L7.76379 12.9112L7.57329 13.5L8.05254 13.1317L8.52204 13.494L8.33379 12.9112L8.80029 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 9.92925H8.23029L8.05029 9.375L7.87854 9.92925H7.30029L7.76379 10.2862L7.57329 10.875L8.05254 10.5067L8.52204 10.869L8.33379 10.2862L8.80029 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 7.30425H8.23029L8.05029 6.75L7.87854 7.30425H7.30029L7.76379 7.66125L7.57329 8.25L8.05254 7.88175L8.52204 8.244L8.33379 7.66125L8.80029 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 4.67925H8.23029L8.05029 4.125L7.87854 4.67925H7.30029L7.76379 5.03625L7.57329 5.625L8.05254 5.25675L8.52204 5.619L8.33379 5.03625L8.80029 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.80029 2.05425H8.23029L8.05029 1.5L7.87854 2.05425H7.30029L7.76379 2.41125L7.57329 3L8.05254 2.63175L8.52204 2.994L8.33379 2.41125L8.80029 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 12.5543H5.3299L5.1499 12L4.97815 12.5543H4.3999L4.8634 12.9112L4.6729 13.5L5.15215 13.1317L5.62165 13.494L5.4334 12.9112L5.8999 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 9.92925H5.3299L5.1499 9.375L4.97815 9.92925H4.3999L4.8634 10.2862L4.6729 10.875L5.15215 10.5067L5.62165 10.869L5.4334 10.2862L5.8999 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 7.30425H5.3299L5.1499 6.75L4.97815 7.30425H4.3999L4.8634 7.66125L4.6729 8.25L5.15215 7.88175L5.62165 8.244L5.4334 7.66125L5.8999 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 4.67925H5.3299L5.1499 4.125L4.97815 4.67925H4.3999L4.8634 5.03625L4.6729 5.625L5.15215 5.25675L5.62165 5.619L5.4334 5.03625L5.8999 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5.8999 2.05425H5.3299L5.1499 1.5L4.97815 2.05425H4.3999L4.8634 2.41125L4.6729 3L5.15215 2.63175L5.62165 2.994L5.4334 2.41125L5.8999 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 12.5543H2.43L2.25 12L2.07825 12.5543H1.5L1.9635 12.9112L1.773 13.5L2.25225 13.1317L2.72175 13.494L2.5335 12.9112L3 12.5543Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 9.92925H2.43L2.25 9.375L2.07825 9.92925H1.5L1.9635 10.2862L1.773 10.875L2.25225 10.5067L2.72175 10.869L2.5335 10.2862L3 9.92925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 7.30425H2.43L2.25 6.75L2.07825 7.30425H1.5L1.9635 7.66125L1.773 8.25L2.25225 7.88175L2.72175 8.244L2.5335 7.66125L3 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 4.67925H2.43L2.25 4.125L2.07825 4.67925H1.5L1.9635 5.03625L1.773 5.625L2.25225 5.25675L2.72175 5.619L2.5335 5.03625L3 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 2.05425H2.43L2.25 1.5L2.07825 2.05425H1.5L1.9635 2.41125L1.773 3L2.25225 2.63175L2.72175 2.994L2.5335 2.41125L3 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 7.30425H16.93L16.75 6.75L16.5783 7.30425H16L16.4635 7.66125L16.273 8.25L16.7523 7.88175L17.2218 8.244L17.0335 7.66125L17.5 7.30425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 4.67925H16.93L16.75 4.125L16.5783 4.67925H16L16.4635 5.03625L16.273 5.625L16.7523 5.25675L17.2218 5.619L17.0335 5.03625L17.5 4.67925Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.5 2.05425H16.93L16.75 1.5L16.5783 2.05425H16L16.4635 2.41125L16.273 3L16.7523 2.63175L17.2218 2.994L17.0335 2.41125L17.5 2.05425Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M8.3617 20H1V22H5.02837L8.3617 20Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M15.0283 16H1V18H11.695L15.0283 16Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M21.695 12H18V14H18.3617L21.695 12Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M25.0283 10L28.3616 8H18V10H25.0283Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M35.0283 4H18V6H31.695L35.0283 4Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M18 1V2H38.3616L39.8921 1.08171L39.895 1.07803C39.7391 1.02738 39.5728 1 39.4001 1H18Z",
                        fill: "#B22234",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M2.22949 24.8461C2.46666 24.9453 2.72699 25 3.0001 25H3.61732L16.0003 17H15.3053L2.23891 24.8399L2.22949 24.8461Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M16.9717 16H17.9998V25H23.9998V16H40.9988V10H26.9717L16.9717 16Z",
                        fill: "#CF142B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "fr"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M5 25H37V1H5V25Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H14V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#002395",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M28 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H28V25Z",
                        fill: "#ED2939",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ru"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#0039A6",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#D52B1E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "de"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#DD0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#FFCE00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "es"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#C50A1D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 19H41V7H1V19Z",
                        fill: "#FFC300",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "12",
                        width: "1",
                        height: "4",
                        fill: "#C4C4C4",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "12",
                        width: "1",
                        height: "4",
                        fill: "#C4C4C4",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "11",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "9",
                        y: "16",
                        width: "1",
                        height: "1",
                        fill: "#367197",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "11",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "18",
                        y: "16",
                        width: "1",
                        height: "1",
                        fill: "#367197",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "11",
                        y: "11",
                        width: "3",
                        height: "3",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11 9.5L14 8.5L17 9.5L16.5 10H11.5L11 9.5Z",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11 14H14V17C12.3431 17 11 15.6569 11 14Z",
                        fill: "#BA640D",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "14",
                        y: "11",
                        width: "3",
                        height: "3",
                        fill: "#CCCCCC",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M14 14H17C17 15.6569 15.6569 17 14 17V14Z",
                        fill: "#AD1519",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "12",
                        y: "12",
                        width: "1",
                        height: "1",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "13",
                        y: "13",
                        width: "2",
                        height: "2",
                        rx: "1",
                        fill: "#005BBF",
                      },
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      attrs: {
                        x: "15",
                        y: "12",
                        width: "1",
                        height: "1",
                        fill: "#ED72AA",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11.5 10H16.5L16 11H12L11.5 10Z",
                        fill: "#C8B100",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "es-us"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M5 13H21V1H5V13Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 13H21V7H1V13Z",
                            fill: "#D52B1E",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 7H8V1H3C1.89543 1 1 1.89543 1 3V7Z",
                            fill: "#0039A6",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M4.95778 3.512H6.5L5.25733 4.512L5.73867 6L4.50178 5.084L3.26489 6L3.75289 4.44933L2.5 3.512H4.03689L4.50178 2L4.95778 3.512Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip1_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 13H35V1H21V13Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 13H27V1H21V13Z",
                            fill: "#006847",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M32.1182 9.26513L32.1252 9.40363L32.1782 9.36913L32.1377 9.25513L32.1182 9.26513Z",
                            fill: "#FCCA3E",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M35 13H41V3C41 1.89543 40.1046 1 39 1H35V13Z",
                            fill: "#CE1126",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M28.5 6.625C28.7071 6.625 28.875 6.79289 28.875 7V7.1C28.875 8.21838 29.7816 9.125 30.9 9.125H31.1C32.2184 9.125 33.125 8.21838 33.125 7.1V7C33.125 6.79289 33.2929 6.625 33.5 6.625C33.7071 6.625 33.875 6.79289 33.875 7V7.1C33.875 8.63259 32.6326 9.875 31.1 9.875H30.9C29.3674 9.875 28.125 8.63259 28.125 7.1V7C28.125 6.79289 28.2929 6.625 28.5 6.625Z",
                            fill: "#9CA168",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M30 5.5C30 5.22386 30.2239 5 30.5 5H31.5C31.7761 5 32 5.22386 32 5.5V7.5C32 7.77614 31.7761 8 31.5 8H30.5C30.2239 8 30 7.77614 30 7.5V5.5Z",
                            fill: "#8F4620",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M31 5.5C31 5.22386 31.2239 5 31.5 5H31.691C31.8804 5 32.0535 5.107 32.1382 5.27639L32.6382 6.27639C32.8044 6.60884 32.5627 7 32.191 7H31.5C31.2239 7 31 6.77614 31 6.5V5.5Z",
                            fill: "#4D2A15",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M29.6315 7.55584C29.6697 7.35228 29.8656 7.2182 30.0692 7.25637L32.0692 7.63137C32.2727 7.66954 32.4068 7.86549 32.3686 8.06905C32.3305 8.27261 32.1345 8.40669 31.931 8.36852L29.931 7.99352C29.7274 7.95535 29.5933 7.7594 29.6315 7.55584Z",
                            fill: "#0C8489",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip2_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 21H21V13H1V21Z",
                            fill: "#FCD116",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 21.9995H21V19H1V21.9995Z",
                            fill: "#003893",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H21V22H1V23Z",
                            fill: "#CE1126",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip3_5514_23364)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 25H39C40.1046 25 41 24.1046 41 23V13H21V25Z",
                            fill: "#71AAE0",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M21 22H41V16H21V22Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "31",
                            cy: "19",
                            r: "2",
                            fill: "#FBE19F",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "31",
                            cy: "19",
                            r: "1",
                            fill: "#F6B40E",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(1 1)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip1_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(21 1)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip2_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(1 13)",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("clipPath", { attrs: { id: "clip3_5514_23364" } }, [
                        _c("rect", {
                          attrs: {
                            width: "20",
                            height: "12",
                            fill: "white",
                            transform: "translate(21 13)",
                          },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "br"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#009B3A",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M6 13L21.0009 2L36 13L21.0009 24L6 13Z",
                        fill: "#FEDF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 20.5C25.1435 20.5 28.5 17.1435 28.5 13C28.5 8.85912 25.1435 5.5 21 5.5C16.8565 5.5 13.5 8.85912 13.5 13C13.5 17.1435 16.8565 20.5 21 20.5Z",
                        fill: "#002776",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M28.0026 15.6264C26.7302 14.4537 24.4573 12.8523 21.7423 11.774C18.452 10.4673 15.1176 10.6367 13.8452 10.7117C13.9335 10.4902 14.1893 9.81609 14.3614 9.48609C16.0008 9.41374 19.1076 9.41638 22.1923 10.6402C24.7573 11.6576 26.9579 13.1276 28.3696 14.3223C28.2893 14.7361 28.1949 15.374 28.0026 15.6264Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "pt"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H16V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#006600",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.0358 16.6053C20.7784 16.9795 20.4735 17.3188 20.134 17.6195C19.153 18.4479 17.91 18.9739 16.4776 18.9993C14.952 19.0276 13.5057 18.1718 12.8529 17.6129C12.8277 17.5902 12.8026 17.5676 12.7783 17.5441C12.7121 17.4847 12.6478 17.4253 12.6049 17.3753C11.732 16.3885 11.0224 15.1331 11 13.4422C11.0504 12.5486 11.2453 11.788 11.5446 11.1311C12.4379 9.28467 14.3272 8 16.4972 8C19.5148 8 22 10.4779 22 13.5072C22 13.9313 21.9468 14.3442 21.8536 14.741C21.6699 15.4592 21.3668 16.101 21.0358 16.6053ZM23 13.4786C23 9.91011 20.0619 7 16.4907 7C12.9107 7 10 9.91834 10 13.5005C10 17.0799 12.9154 20 16.4907 20C20.0197 20 23 16.9828 23 13.4786Z",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 13.4999C12 15.9852 14.0147 17.9999 16.5 17.9999C18.9853 17.9999 21 15.9852 21 13.4999V8.00988L12 7.99988V13.4999Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M19 9.99988V13.4999C19 14.8806 17.8807 15.9999 16.5 15.9999C15.1193 15.9999 14 14.8806 14 13.4999V9.99988H19ZM12.5 13.4999C12.5 15.709 14.2909 17.4999 16.5 17.4999C18.7091 17.4999 20.5 15.709 20.5 13.4999L20.5 8.49988H12.5V13.4999Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17 12.5714C17 12.6888 16.9431 12.7957 16.8531 12.8737C16.7622 12.9516 16.6364 12.9999 16.5005 12.9999C16.3616 12.9999 16.2368 12.9525 16.1469 12.8745C16.0559 12.7965 16 12.6896 16 12.5722V12.0007L16.999 11.9999L17 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 10.5719C16 10.6893 16.0569 10.7963 16.1469 10.8744C16.2378 10.9524 16.3636 10.9999 16.4995 10.9999C16.6384 10.9999 16.7632 10.9524 16.8531 10.8752C16.9441 10.7971 17 10.6901 17 10.5727V10.0007L16.001 9.99988L16 10.5719Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14 12.5714C14 12.6888 14.0569 12.7957 14.1469 12.8737C14.2378 12.9516 14.3636 12.9999 14.5005 12.9999C14.6384 12.9999 14.7632 12.9525 14.8531 12.8745C14.9441 12.7965 15 12.6896 15 12.5722V12.0007L14.002 11.9999L14 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M18 12.5714C18 12.8068 18.2275 12.9999 18.5005 12.9999C18.7769 12.9999 19 12.8063 19 12.5722V12.0007L18.002 11.9999L18 12.5714Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M16 14.5719C16 14.6893 16.0569 14.7963 16.1469 14.8744C16.2378 14.9524 16.3636 14.9999 16.4995 14.9999C16.6384 14.9999 16.7632 14.9524 16.8531 14.8744C16.9441 14.7971 17 14.6901 17 14.5727V14.0007L16.001 13.9999L16 14.5719Z",
                        fill: "#003399",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 17 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 20 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 20 11.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 19.5 14.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14 8.99988)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14 11.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "0.5",
                        cy: "0.5",
                        r: "0.5",
                        transform: "matrix(-1 0 0 1 14.5 14.9999)",
                        fill: "#FFFF00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "zh-Hans"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#FE5C55",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.9634 11.2147H14.4562V22.1517H12.9634V11.2147ZM27.0288 22.0723H25.0945L24.7371 20.7435L26.7134 20.7844C27.239 20.7844 27.5123 20.4777 27.5123 19.8849V10.3585H19.3549V9.00925H29.0051V20.2938C29.0051 21.4794 28.3323 22.0723 27.0288 22.0723ZM17.1684 12.177H24.7582V19.884H17.1684V12.177ZM23.3495 18.6369V16.5927H18.619V18.6369H23.3495ZM18.619 15.4068H23.3495V13.4034H18.619V15.4068ZM15.0869 8.16924C16.2012 9.10962 17.0632 9.92733 17.6519 10.6428L16.5376 11.3992C15.9069 10.6428 15.0449 9.78423 13.9726 8.84386L15.0869 8.16924ZM14.6033 6.14632C14.0567 7.04581 13.468 7.88397 12.7952 8.64036L11.5127 7.84309C12.7742 6.47341 13.6992 4.96063 14.2879 3.3252L15.7596 3.63184C15.5914 4.06114 15.4232 4.47 15.2551 4.85842H20.8055V6.14632H17.6518C18.1775 6.86182 18.5979 7.53644 18.8923 8.17017L17.5467 8.6608C17.1262 7.78176 16.6216 6.9436 16.054 6.14632H14.6033ZM23.5387 6.14641C23.1182 6.92324 22.6557 7.63875 22.1301 8.29292L20.8476 7.49565C21.8988 6.22818 22.6557 4.85851 23.1182 3.34573L24.5689 3.65237C24.4427 4.06123 24.2956 4.47009 24.1274 4.85851H30.2665V6.14641H26.7765C27.26 6.80059 27.6595 7.43432 27.9749 8.00672L26.6293 8.49735C26.2088 7.67963 25.7252 6.9028 25.1576 6.14641H23.5387Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "zh-Hant"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#43D281",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6115 6.18669C14.3321 6.52387 14.0326 6.84121 13.7331 7.15856H20.5409C20.5409 7.97175 20.5209 8.7056 20.481 9.37996H21.6988V10.332H20.4011C20.3413 10.8675 20.2614 11.3633 20.1815 11.7997H21.0999V12.5931H20.0019C19.9619 12.7121 19.942 12.8311 19.902 12.9501L20.461 13.3467C19.2832 13.9616 18.0454 14.4773 16.7677 14.9136L21.5591 14.7549C22.3976 14.3384 23.236 13.9021 24.0745 13.4261L25.1127 14.1004C22.5972 15.5285 19.8821 16.6392 16.9673 17.4127C19.922 17.3135 22.8767 17.1549 25.8114 16.9565C25.3123 16.5598 24.7733 16.183 24.2143 15.7863L25.2325 15.1516C27.0891 16.3417 28.5066 17.3929 29.5048 18.3052L28.3668 19.0986C27.9276 18.6622 27.4485 18.2457 26.9094 17.8094C25.0727 17.9085 23.3359 18.0077 21.6988 18.087V20.725C21.6988 21.5977 21.1797 22.0538 20.1815 22.0538H18.2051L17.9456 20.9035C18.5844 20.9431 19.1833 20.9828 19.7623 20.9828C20.1416 20.9828 20.3413 20.7845 20.3413 20.4076V18.1465C17.9256 18.2656 15.7096 18.3449 13.6732 18.3846L13.3738 17.1945C13.7531 17.2144 14.1324 17.2342 14.5317 17.2342C16.2486 16.8772 18.0054 16.302 19.8222 15.5483L14.6515 15.707L14.4319 14.6756C14.9509 14.6756 15.3303 14.6161 15.5499 14.5368C16.5281 14.1798 17.5463 13.7434 18.6243 13.1881C18.7042 12.9699 18.7641 12.7716 18.824 12.5931H12.8946C13.0344 11.8394 13.1542 11.0857 13.274 10.332H11.8765V9.37996H13.4137C13.4936 8.66593 13.5734 7.97175 13.6333 7.25773L12.6151 8.15025L11.8765 7.25773C13.0344 6.38503 14.0126 5.23467 14.7713 3.80662L15.9691 4.0843C15.7695 4.46114 15.5499 4.81815 15.3502 5.15533H21.4193V6.18669H14.6115ZM14.4519 10.2133C14.372 10.7488 14.2722 11.2844 14.1724 11.8H19.0236C19.1235 11.2844 19.2033 10.7687 19.2632 10.2133H14.4519ZM19.3231 9.53835C19.363 9.02267 19.403 8.48715 19.4229 7.9318H14.7314L14.5517 9.53835H19.3231ZM23.6953 6.86005C23.9947 8.01041 24.6336 9.04178 25.6118 9.91447C26.3904 9.06161 26.9494 8.05008 27.2688 6.86005H23.6953ZM24.7534 10.7085C23.9149 9.85562 23.3159 8.90359 22.9366 7.87223C22.5573 8.36808 22.178 8.82426 21.7787 9.22093L21.0201 8.30857C22.1381 7.15821 23.0764 5.67066 23.7951 3.80627L25.0329 4.08395C24.7933 4.65913 24.5537 5.19465 24.2942 5.71033H29.6645V6.8607H28.4667C28.0874 8.38791 27.4485 9.65728 26.5701 10.6688C27.5284 11.3233 28.7262 11.8985 30.1237 12.3745L29.4649 13.5051C27.9476 12.9497 26.6899 12.2754 25.6917 11.5217C24.6935 12.3547 23.4557 12.9497 21.9783 13.3266L21.2996 12.2754C22.6971 11.9382 23.835 11.4225 24.7534 10.7085ZM16.0889 8.10994C16.8476 8.32811 17.5263 8.60579 18.1452 8.94296L17.7859 9.49831C17.1071 9.1413 16.4084 8.86363 15.7096 8.66529L16.0889 8.10994ZM15.7695 10.3513C16.588 10.5695 17.3267 10.8273 17.9855 11.1447L17.6062 11.7199C16.8875 11.3629 16.1488 11.105 15.4101 10.9067L15.7695 10.3513ZM24.0945 18.8001C26.0909 19.3158 27.9076 19.9306 29.5447 20.6645L28.826 21.795C27.0691 20.962 25.2524 20.3273 23.3758 19.8513L24.0945 18.8001ZM17.3267 18.8598L18.0853 19.7325C16.6479 20.5655 14.8511 21.2597 12.695 21.8151L12.156 20.7044C14.2323 20.2283 15.9691 19.6135 17.3267 18.8598Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ee"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V6H1V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#0072CE",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "jp"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15 13C15 9.68523 17.6862 7 21 7C24.3138 7 27 9.68523 27 13C27 16.3148 24.3138 19 21 19C17.6862 19 15 16.3148 15 13Z",
                        fill: "#BC002D",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "hi" || this.value === "in"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 20H41V6H1V20Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#FF9933",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#128807",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 10C22.6569 10 24 11.3431 24 13C24 14.6569 22.6569 16 21 16C19.3431 16 18 14.6569 18 13C18 11.3431 19.3431 10 21 10Z",
                        fill: "#000088",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 10.5C22.3802 10.5 23.5 11.6192 23.5 13.0004C23.5 14.3808 22.3802 15.5 21 15.5C19.6198 15.5 18.5 14.3808 18.5 13.0004C18.5 11.6192 19.6198 10.5 21 10.5Z",
                        fill: "#CCCCE7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21 12.5C21.2761 12.5 21.5 12.7237 21.5 12.9996C21.5 13.2755 21.2761 13.5 21 13.5C20.7239 13.5 20.5 13.2755 20.5 12.9996C20.5 12.7237 20.7239 12.5 21 12.5Z",
                        fill: "#000088",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "pl"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#DC143C",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "it"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H15V1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#009246",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15 25H27V1H15V25Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27 25H38.999C40.1036 25 40.999 24.1046 40.999 23V3C40.999 1.89543 40.1036 1 38.999 1H27V25Z",
                        fill: "#CE2B37",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "nl"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V6H1V23Z",
                        fill: "#21468B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#AE1C28",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "ua"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "#005BBB",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#FFD500",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "toefl" || this.value === "toefl-ja"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#787AB4",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14.6029 14.9486C14.4869 15.4297 14.4253 15.9323 14.4253 16.4491L20.7996 18.7035L27.1736 16.4491C27.1736 15.9323 27.1122 15.4297 26.9959 14.9486L26.3269 12.0487H15.2376L14.6029 14.9486Z",
                        fill: "#5B9DB0",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.59863 11.7467L20.7992 8.03296L33.9998 11.7467L20.7992 15.7742L7.59863 11.7467Z",
                        fill: "#6CD5E5",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M20.9351 7.5514C20.8466 7.52649 20.7528 7.52649 20.6643 7.5514L7.46371 11.2651C7.25004 11.3252 7.10158 11.519 7.09915 11.741C7.09672 11.9629 7.24091 12.1599 7.45321 12.2247L12.6006 13.7952V16.8409C12.4012 16.992 12.2725 17.2314 12.2725 17.501C12.2725 17.6601 12.3173 17.8088 12.3951 17.9349L12.4572 19.7199C12.4665 19.9884 12.6864 20.2016 12.9552 20.2025L13.2011 20.2033C13.4676 20.2042 13.688 19.9959 13.7021 19.7297L13.7962 17.9489C13.8794 17.8199 13.9277 17.6661 13.9277 17.501C13.9277 17.2318 13.7993 16.9929 13.6006 16.8418V14.1003L14.2345 14.2937L14.1156 14.8368C13.9912 15.3543 13.9253 15.8946 13.9253 16.4493C13.9253 16.6612 14.0588 16.8501 14.2586 16.9207L20.6329 19.1751C20.7407 19.2132 20.8584 19.2132 20.9663 19.1751L27.3403 16.9207C27.54 16.8501 27.6736 16.6612 27.6736 16.4493C27.6736 15.8938 27.6077 15.3526 27.4825 14.8339L27.3584 14.2957L34.1462 12.2247C34.3585 12.1599 34.5027 11.9629 34.5002 11.741C34.4978 11.519 34.3493 11.3252 34.1357 11.2651L20.9351 7.5514ZM26.3996 14.5882L20.9456 16.2522C20.8505 16.2812 20.7489 16.2812 20.6538 16.2522L15.1941 14.5864L15.0891 15.066C15.0086 15.3999 14.9563 15.7454 14.9355 16.0995L20.7996 18.1733L26.6634 16.0994C26.6426 15.7453 26.5906 15.3999 26.5099 15.0663L26.5087 15.0612L26.3996 14.5882ZM14.9051 13.4528L20.7997 15.2512L32.2232 11.7659L20.7997 8.55212L9.37624 11.7659L13.1348 12.9127L20.6648 10.7908C20.9306 10.7159 21.2068 10.8707 21.2817 11.1365C21.3565 11.4023 21.2018 11.6785 20.936 11.7534L14.9051 13.4528Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "toeic"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23355)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#787AB4",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M26.8646 13.0009C26.8646 16.489 24.037 19.3167 20.5488 19.3167C17.0606 19.3167 14.2329 16.489 14.2329 13.0009C14.2329 9.5128 17.0606 6.68506 20.5488 6.68506C24.037 6.68506 26.8646 9.5128 26.8646 13.0009Z",
                        fill: "#63E1E7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.733 12.9672C13.7323 12.978 13.7319 12.989 13.7319 13C13.7319 13.011 13.7323 13.0219 13.733 13.0326C13.7501 16.7823 16.7951 19.8167 20.5488 19.8167C24.3132 19.8167 27.3646 16.7651 27.3646 13.0009C27.3646 9.26226 24.3546 6.22659 20.6255 6.18548C20.6003 6.18457 20.5749 6.18411 20.5495 6.18408H20.5475C20.521 6.18408 20.4946 6.18457 20.4683 6.18552C16.7523 6.22854 13.751 9.24531 13.733 12.9672ZM14.7542 12.5H16.899C16.9276 11.7418 17.0207 11.0151 17.1693 10.3423H15.416C15.4024 10.3423 15.3889 10.3417 15.3756 10.3407C15.0371 10.9976 14.8201 11.7272 14.7542 12.5ZM18.244 7.65965C17.3749 8.03515 16.6157 8.61652 16.0276 9.34229H17.444C17.5672 8.97272 17.709 8.6271 17.8673 8.31036C17.9814 8.08225 18.1071 7.86381 18.244 7.65965ZM22.8501 7.65811C22.9874 7.86271 23.1134 8.08167 23.2278 8.31036C23.3861 8.6271 23.5279 8.97272 23.6512 9.34229H25.0699C24.4811 8.61553 23.7206 8.03356 22.8501 7.65811ZM25.7218 10.3405C25.7078 10.3417 25.6936 10.3423 25.6793 10.3423H23.9258C24.0744 11.0151 24.1675 11.7418 24.1961 12.5H26.3433C26.2774 11.7272 26.0603 10.9974 25.7218 10.3405ZM26.3435 13.5H24.1961C24.1675 14.2584 24.0743 14.9852 23.9257 15.6582H25.6793C25.6938 15.6582 25.7082 15.6588 25.7225 15.66C26.0609 15.0029 26.2778 14.273 26.3435 13.5ZM25.071 16.6582H23.6509C23.5278 17.0275 23.3861 17.3729 23.2278 17.6895C23.1129 17.9192 22.9862 18.1391 22.8483 18.3445C23.72 17.9688 24.4816 17.3861 25.071 16.6582ZM18.2458 18.3429C18.1082 18.138 17.9819 17.9186 17.8673 17.6895C17.7091 17.3729 17.5673 17.0275 17.4442 16.6582H16.0266C16.6152 17.3851 17.3755 17.9672 18.2458 18.3429ZM15.375 15.6599C15.0366 15.0028 14.8197 14.273 14.754 13.5H16.899C16.9276 14.2584 17.0208 14.9852 17.1695 15.6582H15.416C15.4022 15.6582 15.3885 15.6588 15.375 15.6599ZM17.8998 12.5C17.9314 11.7253 18.0355 10.9972 18.196 10.3423H20.0479V12.5H17.8998ZM21.0479 12.5V10.3423H22.8991C23.0596 10.9972 23.1638 11.7253 23.1953 12.5H21.0479ZM21.0479 9.34229H22.5894C22.5101 9.13525 22.4245 8.93991 22.3333 8.75757C21.9405 7.97182 21.4876 7.50115 21.0479 7.29968V9.34229ZM18.5057 9.34229H20.0479V7.29938C19.6079 7.50067 19.1548 7.97141 18.7618 8.75757C18.6706 8.9399 18.585 9.13524 18.5057 9.34229ZM18.506 16.6582C18.5852 16.865 18.6707 17.0601 18.7618 17.2423C19.1548 18.0284 19.6079 18.4992 20.0479 18.7005V16.6582H18.506ZM20.0479 15.6582H18.1962C18.0356 15.0032 17.9314 14.2749 17.8998 13.5H20.0479V15.6582ZM21.0479 16.6582V18.7002C21.4876 18.4987 21.9405 18.028 22.3333 17.2423C22.4244 17.0601 22.5099 16.865 22.5891 16.6582H21.0479ZM22.8989 15.6582H21.0479V13.5H23.1953C23.1638 14.2749 23.0596 15.0032 22.8989 15.6582Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M30.9973 12.482C30.8161 12.2736 30.5003 12.2515 30.2919 12.4327L29.1684 13.4094C28.96 13.5905 28.9379 13.9063 29.1191 14.1147C29.3002 14.3232 29.6161 14.3452 29.8245 14.1641L29.9952 14.0156C29.4883 18.7847 25.4527 22.4999 20.549 22.4999C16.0919 22.4999 12.3507 19.4303 11.3263 15.2892C11.26 15.0212 10.9889 14.8576 10.7209 14.9239C10.4528 14.9902 10.2893 15.2613 10.3556 15.5294C11.4878 20.1062 15.6214 23.4999 20.549 23.4999C26.0072 23.4999 30.4924 19.3353 31.0009 14.0104L31.2192 14.2616C31.4004 14.47 31.7162 14.4921 31.9246 14.3109C32.133 14.1298 32.1551 13.8139 31.9739 13.6055L30.9973 12.482Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M10.0993 13.5178C10.2805 13.7262 10.5963 13.7483 10.8047 13.5671L11.9282 12.5905C12.1366 12.4093 12.1587 12.0935 11.9775 11.8851C11.7963 11.6767 11.4805 11.6546 11.2721 11.8357L11.1016 11.984C11.6086 7.21505 15.6442 3.5 20.5477 3.5C25.0047 3.5 28.7459 6.56962 29.7703 10.7106C29.8366 10.9787 30.1076 11.1422 30.3757 11.0759C30.6438 11.0096 30.8073 10.7385 30.741 10.4705C29.6088 5.89368 25.4752 2.5 20.5477 2.5C15.0895 2.5 10.6043 6.66472 10.0959 11.9896L9.87736 11.7382C9.6962 11.5298 9.38038 11.5077 9.17198 11.6889C8.96357 11.8701 8.94149 12.1859 9.12265 12.3943L10.0993 13.5178Z",
                        fill: "#1E222E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23355" } }, [
                        _c("rect", {
                          attrs: {
                            width: "40",
                            height: "24",
                            fill: "white",
                            transform: "translate(1 1)",
                          },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "pirate"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23353)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M28.7623 14.7998C28.5943 14.5558 28.4373 14.1598 28.3123 13.6328C28.2883 13.5328 27.4883 13.2748 27.4673 13.1658C27.4353 13.0028 27.9643 13.1518 27.9383 12.9688C27.8573 12.3928 28.0303 11.5548 28.0303 10.7998C28.0303 9.79976 28.0803 7.99976 26.7053 5.99976C25.8413 4.74276 23.5623 3.99976 21.2053 3.99976C18.8483 3.99976 17.0103 4.79976 15.9013 5.99976C14.4783 7.54076 14.0253 9.59976 14.0253 10.5998C14.0253 11.9468 14.1053 13.3998 14.1343 14.1998C14.1383 14.3408 14.7323 13.8838 14.7233 13.9998C14.7053 14.2038 14.4123 15.2798 14.3303 15.4008C14.1593 15.6488 13.8823 16.0378 14.0553 16.3498C14.5263 17.1998 14.6373 17.9998 14.9193 17.9998C15.3123 17.9998 16.3953 17.7308 16.8243 17.1998C17.1953 16.7408 17.7333 15.9928 17.9233 16.1998C18.2973 16.6088 18.2413 17.9118 17.8753 18.3128C17.3313 18.9068 17.3733 19.0718 17.3733 19.5998C17.3733 20.1998 18.1063 20.1998 18.1063 20.1998C18.1063 20.1998 18.2593 20.7998 18.6513 20.4008C18.9893 20.0568 18.5113 21.1618 19.0443 20.7998C19.6343 20.4008 19.4483 20.9408 19.6853 20.9408C19.8313 20.9408 20.0893 19.3738 20.2233 19.4008C21.6043 19.6668 20.9773 20.5828 21.0753 20.5828H21.5003C22.0903 20.5828 21.7983 19.9998 21.9913 19.9998C22.2373 19.9998 22.1793 20.9998 22.4193 20.9998C22.6483 20.9998 22.4703 21.0598 22.7843 20.9848C23.1703 20.8938 22.7583 19.9788 23.1043 19.8328C23.7923 19.5458 24.5043 20.2918 24.6883 20.2918C25.2393 20.2918 24.6813 19.8918 24.6813 19.8918C24.6813 19.8918 25.0743 19.9998 25.0743 19.4008C25.0743 18.8718 25.4353 18.5948 24.8913 17.9998C24.5253 17.5998 24.5633 16.8088 24.9373 16.4008C25.1273 16.1928 25.5493 16.1418 25.9193 16.5998C26.3483 17.1308 26.5093 17.1998 26.9023 17.1998C27.2003 17.1998 27.6973 15.9298 28.6693 15.5998C29.2593 15.4008 28.9113 15.0178 28.7623 14.7998Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M19.9241 13.8007C19.5441 14.5387 19.7341 14.9997 18.4841 14.9997C17.2351 14.9997 16.0161 14.6617 16.0161 13.8007C16.0161 12.9397 15.7951 11.6427 17.0441 11.6427C18.0731 11.6427 18.6661 12.4517 19.1011 12.8417C19.5361 13.2317 20.2331 13.2007 19.9241 13.8007Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M22.0776 13.8007C22.4576 14.5387 22.2676 14.9997 23.5176 14.9997C24.7666 14.9997 25.9856 14.6617 25.9856 13.8007C25.9856 12.9397 26.2066 11.6427 24.9576 11.6427C23.9286 11.6427 23.3356 12.4517 22.9006 12.8417C22.4656 13.2317 21.7686 13.2007 22.0776 13.8007Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M20.4464 15.3104C20.2494 15.7244 19.2634 17.9994 20.0514 17.9994C21.2354 17.9994 20.2994 17.1724 20.8414 17.1724C21.6294 17.1724 21.0384 17.9994 21.8264 17.9994C22.8954 17.9994 21.6294 15.7244 21.4324 15.3104C21.2354 14.8964 20.6434 14.8964 20.4464 15.3104Z",
                            fill: "#292F32",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M33.4385 9.00872C33.9395 8.51372 34.6915 9.25672 36.1965 9.00872C37.7005 8.76072 37.1915 6.62672 36.4395 6.37972C35.6875 6.13172 33.3025 8.18773 34.1245 6.60872C34.6375 5.62272 34.2455 3.96772 33.3025 3.99972C31.6545 4.05672 32.2935 5.92372 32.0425 6.66672C31.9665 6.89272 32.8675 7.13172 29.9345 8.51272L29.4385 8.72572C29.4385 8.72572 30.5085 8.84472 29.9385 9.21972C29.3685 9.59472 30.3145 9.48572 29.9345 9.82472C29.5545 10.1657 29.9385 10.7007 29.9385 10.7007C33.3165 9.23773 33.2705 9.17472 33.4385 9.00872Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M8.78639 17.5937C8.03439 17.8417 8.30439 16.1797 6.20639 16.6057C4.97539 16.8567 4.58539 18.6637 5.51239 19.1207C6.43739 19.5777 8.95139 18.5627 7.62539 19.9997C6.90939 20.7777 7.28239 22.0517 8.78639 22.5467C10.2904 23.0427 10.0394 19.8227 10.0394 19.3277C10.0394 19.2147 9.69339 19.1077 11.4764 18.2967C11.4764 18.2967 13.2924 18.8747 11.9594 17.4167C11.9594 17.4167 11.1254 17.5807 11.4764 17.0477C12.1834 15.9717 11.4764 16.2007 11.4764 16.2007C8.99539 17.3027 8.78639 17.5937 8.78639 17.5937Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M10.4241 7.05562C8.43107 5.69862 10.7531 3.81562 9.17807 3.85662C4.69507 3.97562 7.68407 6.92762 7.68407 6.92762C9.37607 7.99962 6.68807 7.41962 6.43907 7.66562C6.19007 7.91162 4.69507 10.7456 6.68807 10.0076C8.68007 9.26962 8.43107 8.53162 9.17807 8.77762C9.17807 8.77762 9.24907 8.80062 11.8761 9.96862L11.5251 9.25962C11.5251 9.25962 11.7381 8.97562 11.3591 8.60062C10.9791 8.22562 10.7361 8.24562 11.8761 8.33962C12.6841 8.40662 12.2351 7.45762 12.2351 7.45762C11.3761 7.45762 10.5201 7.12062 10.4241 7.05562Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M34.0073 16.4716C33.7973 16.3856 34.1933 16.3326 31.0633 14.9346V15.4256C31.0633 15.4256 31.4503 15.8786 30.5013 15.9416C29.5513 16.0036 31.0873 17.2366 29.9473 17.0486C30.1373 17.6116 31.1253 17.6936 31.1253 17.6936C33.8363 18.9746 32.9393 18.4726 33.0113 18.6866C33.2603 19.4246 32.5573 20.5556 33.2563 20.6386C34.2523 20.7576 36.4983 21.7576 35.5023 19.1786C35.1043 18.1506 35.5023 18.9326 36.2493 18.6866C36.9963 18.4406 38.7393 18.0666 37.6183 16.4676C36.4983 14.8676 35.5023 17.0826 34.0073 16.4716Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                            fill: "#626C91",
                            "fill-opacity": "0.5",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23353" } }, [
                        _c("rect", {
                          attrs: { width: "42", height: "26", fill: "white" },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "ar"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#1B875B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27 18.5755C25.901 19.4696 24.6117 20.1517 23.132 20.6217C22.1803 20.8739 21.2134 21 20.231 21C18.7513 21 17.5096 20.6246 16.5058 19.8737C15.5019 19.1229 15 17.9049 15 16.2198C15 15.5205 15.1167 14.8427 15.35 14.1865C15.5833 13.5302 16.0008 12.8667 16.6025 12.1961C16.891 11.8981 17.1074 11.676 17.2517 11.5298C17.396 11.3837 17.5234 11.2791 17.6339 11.216C16.8419 10.5741 16.4459 9.94931 16.4459 9.34175C16.4152 8.63675 16.9432 7.59359 18.0299 6.21225C18.779 5.40408 19.6048 5 20.5073 5C20.9616 5 21.4175 5.12466 21.8749 5.37399C22.3323 5.62332 22.6669 5.83253 22.8787 6.00161C23.0906 6.1707 23.2686 6.35411 23.4129 6.55185C23.5572 6.7496 23.6293 6.94017 23.6293 7.12359C23.6232 7.15225 23.6078 7.16658 23.5833 7.16658C22.736 6.87999 22.0177 6.7367 21.4282 6.7367C21.1949 6.7367 20.8956 6.78685 20.5303 6.88716C20.165 6.98746 19.7859 7.16944 19.3929 7.4331C19 7.69676 18.8035 7.96328 18.8035 8.23267C18.8035 8.50206 19.0767 8.78864 19.6232 9.09242C20.1696 9.3962 20.4981 9.56815 20.6086 9.60827C20.8419 9.57962 21.7015 9.39047 23.1873 9.04084C23.6662 8.95486 24.0238 8.89038 24.2602 8.84739C24.4965 8.80441 24.8173 8.73706 25.2226 8.64535L24.3661 11.13H24.3016C24.0622 11.13 23.5096 11.2103 22.6439 11.3708C18.4812 12.2764 16.3998 13.7723 16.3998 15.8587C16.3998 16.2312 16.6239 16.6496 17.0721 17.1139C18.0668 17.7903 19.2916 18.2087 20.7467 18.3692C21.2072 18.4494 21.6247 18.501 21.9992 18.5239C22.3738 18.5468 23.0184 18.5726 23.9332 18.6013C25.2287 18.5784 26.251 18.5698 27 18.5755Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "kr" || this.value === "ko"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M27.7004 14.107C28.2255 12.0416 26.2557 10.3552 24.6172 10.3552C23.6617 10.3552 22.7421 10.8445 22.1982 11.5455C21.9147 11.9844 20.6733 13.8099 20.4 14.1249C19.8741 14.5903 19.1918 14.9318 18.4379 14.9318C16.7994 14.9318 15.1523 13.5162 15.2078 11.2723C15.2078 11.2723 15.1053 12.1363 15.0977 12.4224C15.1216 16.1511 17.976 18.9432 21.4998 18.9176C24.7068 18.8911 27.054 16.6344 27.7004 14.107Z",
                        fill: "#003478",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M15.2151 11.2768C15.7906 8.33279 18.3846 6.10938 21.4994 6.10938C25.0369 6.10938 27.9049 8.97573 27.9049 12.5115C27.9049 13.0665 27.8341 13.6027 27.7026 14.1142L27.7 14.1065C28.2251 12.0419 26.2553 10.3555 24.6168 10.3555C23.6613 10.3555 22.7417 10.8439 22.1978 11.5449C21.9144 11.9838 20.6729 13.8102 20.3996 14.1253C19.8745 14.5906 19.1915 14.9313 18.4375 14.9313C16.799 14.9313 15.1519 13.5156 15.2074 11.2717L15.2151 11.2768Z",
                        fill: "#C60C30",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.69824 8.14819L9.51622 8.73735L13.2313 3.57671L12.4142 3.00037L8.69824 8.14819Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.1113 9.14221L10.9293 9.7288L14.6444 4.57073L13.8273 3.99438L10.1113 9.14221Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.5239 10.1337L12.3419 10.7228L16.057 5.56218L15.2399 4.98499L11.5239 10.1337Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.8935 9.14221L32.0755 9.7288L28.3579 4.57073L29.1776 3.99438L32.8935 9.14221Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M29.3252 7.11874L28.5072 7.70789L26.9473 5.56218L27.7652 4.98499L29.3252 7.11874Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.4939 10.1336L30.6759 10.7227L29.0903 8.5147L29.9075 7.94092L31.4939 10.1336Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M34.3064 8.14824L33.4884 8.73739L31.9028 6.52935L32.72 5.95386L34.3064 8.14824Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.1379 5.144L31.3199 5.7323L29.771 3.57634L30.5881 3L32.1379 5.144Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11.5859 15.0368L12.4039 14.4502L16.1318 19.6083L15.3147 20.1855L11.5859 15.0368Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M10.1865 16.0303L11.0045 15.4412L12.5875 17.6492L11.7696 18.2255L10.1865 16.0303Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.3521 19.0325L13.17 18.4459L14.7198 20.6027L13.9018 21.1799L12.3521 19.0325Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M8.78662 17.0372L9.6046 16.4489L13.3197 21.6078L12.5026 22.1858L8.78662 17.0372Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.9168 16.0303L32.0988 15.4412L30.5132 17.6492L31.3337 18.2255L32.9168 16.0303Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M30.7515 19.0325L29.9335 18.4459L28.3838 20.6027L29.2018 21.1799L30.7515 19.0325Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M31.5171 15.0368L30.6991 14.4502L29.1152 16.6557L29.9341 17.232L31.5171 15.0368Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M29.3485 18.0407L28.5331 17.4524L26.9834 19.6083L27.8014 20.1855L29.3485 18.0407Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M34.3167 17.0372L33.4987 16.4489L31.9131 18.6543L32.7336 19.2298L34.3167 17.0372Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M32.151 20.0398L31.3331 19.4507L29.7842 21.6075L30.6013 22.1864L32.151 20.0398Z",
                        fill: "black",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "tr"
                ? [
                    _c(
                      "g",
                      { attrs: { "clip-path": "url(#clip0_5514_23345)" } },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                            fill: "#E30A17",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M17.0955 17.7C14.2345 17.7 11.9155 15.371 11.9155 12.5C11.9155 9.629 14.2345 7.3 17.0955 7.3C18.6345 7.3 20.0115 7.977 20.9605 9.047C19.8155 7.217 17.7875 6 15.4745 6C11.9005 6 8.99951 8.909 8.99951 12.5C8.99951 16.091 11.9005 19 15.4745 19C17.7875 19 19.8155 17.783 20.9605 15.953C20.0115 17.022 18.6345 17.7 17.0955 17.7Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M25.2955 12.4998L26.7515 10.5168L24.3955 11.2738L22.9395 9.28979V11.7428L20.5845 12.4998L22.9395 13.2568V15.7098L24.3955 13.7258L26.7515 14.4828L25.2955 12.4998Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                            fill: "#626C91",
                            "fill-opacity": "0.5",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("defs", [
                      _c("clipPath", { attrs: { id: "clip0_5514_23345" } }, [
                        _c("rect", {
                          attrs: { width: "42", height: "26", fill: "white" },
                        }),
                      ]),
                    ]),
                  ]
                : this.value === "th"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 5H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V5Z",
                        fill: "#ED1C24",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V5H1V9Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 21H41V17H1V21Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V21H1V23Z",
                        fill: "#ED1C24",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#241D4F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "az"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 25H41V17H1V25Z",
                        fill: "#509E2F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V1H1V9Z",
                        fill: "#00B5E2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#EF3340",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M21.3222 10.0266C20.8164 9.73336 20.2283 9.56799 19.6028 9.56799C17.6998 9.56799 16.1587 11.1093 16.1587 13.0133C16.1587 14.9172 17.6998 16.4613 19.6028 16.4613C20.2283 16.4613 20.8164 16.2934 21.3222 16.0026C21.0986 16.0533 20.907 16.0746 20.6675 16.0746C18.98 16.0746 17.6119 14.7038 17.6119 13.0133C17.6119 11.3254 18.98 9.95463 20.6675 9.95463C20.9016 9.95463 21.1039 9.97863 21.3222 10.0266",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M22.3897 11.1707L22.0037 11.9441L21.1867 11.6934L21.4955 12.5306L20.689 12.872L21.4955 13.2427L21.1655 14.0747L21.9984 13.7707L22.3897 14.5732L22.7331 13.7921L23.5688 14.0987L23.284 13.2639L24.0905 12.872L23.284 12.5066L23.5928 11.6454L22.7331 12.0028L22.3897 11.1707Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "cz"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 13H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V13Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V13H1V23Z",
                        fill: "#D7141A",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M18.1221 13L1.69434 24.5127C1.26982 24.1459 1 23.605 1 23V3C1 2.39475 1.26954 1.85308 1.69434 1.48633L18.1221 13Z",
                        fill: "#11457E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "sk"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "#0B4EA2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#EE1C25",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.8462 19.3999C10.7496 18.9066 9.46175 17.7199 8.69272 16.2533C6.7957 12.6426 8.0595 7.34122 8.19253 6.59985H17.4998C17.6329 7.34122 18.8968 12.6426 16.9997 16.2533C16.2306 17.7199 14.943 18.9066 12.8462 19.3999Z",
                        stroke: "white",
                        "stroke-width": "0.799171",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M17.4999 6.56091C17.6329 7.30521 18.8967 12.6279 16.9997 16.2533H8.69279C6.79562 12.6279 8.05957 7.30521 8.19259 6.56091H17.4999Z",
                        fill: "#EE1C25",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.3573 14.8959V12.2872H14.4509C14.8952 12.2872 15.547 12.4325 15.8238 12.5995V11.0676C15.547 11.2346 14.8952 11.3772 14.4509 11.3772H13.3573V9.84549H14.1024C14.544 9.84549 14.9645 9.9908 15.2438 10.1578V8.62588C14.9645 8.79285 14.544 8.93817 14.1024 8.93817H13.3573V8.1709C13.3573 7.71593 13.4983 7.28524 13.6607 6.99988H12.0322C12.1947 7.28524 12.3356 7.71593 12.3356 8.1709V8.93817H11.5906C11.1489 8.93817 10.7285 8.79285 10.4491 8.62588V10.1578C10.7285 9.9908 11.1489 9.84549 11.5906 9.84549H12.3356V11.3772H11.242C10.7977 11.3772 10.1485 11.2346 9.86914 11.0676V12.5995C10.1485 12.4325 10.7977 12.2872 11.242 12.2872H12.3356V14.8959H13.3573Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12.8463 19.4C14.9431 18.9067 16.2308 17.72 16.9998 16.2533C16.6859 15.7253 15.5231 14.968 14.4987 15.8213C14.4508 15.3946 13.6606 14.4933 12.8463 14.4933C12.0322 14.4933 11.242 15.3946 11.194 15.8213C10.1696 14.968 9.00692 15.7253 8.69287 16.2533C9.4619 17.72 10.7497 18.9067 12.8463 19.4",
                        fill: "#0B4EA2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "hr"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 9H41V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V9Z",
                        fill: "#FF0000",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 17H41V9H1V17Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V17H1V23Z",
                        fill: "#171796",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "unknown"
                ? [
                    _c("path", {
                      attrs: {
                        d: "M24 14.5C24.3333 13.6667 24.7252 13.7748 26 12.5C27 11.5 27.5 10.5 27.5 9C27.5 8 27.3 6.8 26.5 6",
                        stroke: "#8EA3EE",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M22.6057 20C22.6057 20.7732 21.9789 21.4 21.2057 21.4C20.4325 21.4 19.8057 20.7732 19.8057 20C19.8057 19.2268 20.4325 18.6 21.2057 18.6C21.9789 18.6 22.6057 19.2268 22.6057 20Z",
                        fill: "#2C3143",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M19.033 7.91776C18.5857 8.74417 17.9134 9.09186 17.2738 8.80982C16.6342 8.52779 16.5263 7.98417 16.6373 7.67261C17.2235 6.02723 18.9119 4.5 21.4998 4.5C24.2229 4.5 26.6054 6.08072 26.6054 9.0719C26.6054 9.91318 26.4079 10.5071 26.1257 10.9708C25.1311 12.6052 22.9484 13.1437 22.6129 15.2413C22.4955 15.9753 21.9482 16.4 21.2139 16.4C20.4486 16.4 19.9998 16 19.9663 15.0414C19.9663 12 24.3054 11.271 24.3054 8.99998C24.3054 7.17781 23.1622 6.5 21.4998 6.5C20.4658 6.5 19.4291 7.18602 19.033 7.91776Z",
                        fill: "#2C3143",
                      },
                    }),
                  ]
                : this.value === "no"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#BA0C2F",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M11 1V9H1V17H11V25H19V17H41V9H19V1H11Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13 1V11H1V15H13V25H17V15H41V11H17V1H13Z",
                        fill: "#00205B",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "sv"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#006AA7",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 1V10H1V15H12V25H17V15H41V10H17V1H12Z",
                        fill: "#FECC00",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "da"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "#C8102E",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M14 1V10H1V15H14V25H19V15H41V10H19V1H14Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : this.value === "fi"
                ? [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M1 23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3C1.89543 1 1 1.89543 1 3V23Z",
                        fill: "white",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M12 10V1H18V10H41V16H18V25H12V16H1V10H12Z",
                        fill: "#002F6C",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3 0H39C40.6569 0 42 1.34315 42 3V23C42 24.6569 40.6569 26 39 26H3C1.34315 26 0 24.6569 0 23V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V23C1 24.1046 1.89543 25 3 25H39C40.1046 25 41 24.1046 41 23V3C41 1.89543 40.1046 1 39 1H3Z",
                        fill: "#626C91",
                        "fill-opacity": "0.5",
                      },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : [
            _c("span", { staticClass: "letters" }, [
              _vm._v(_vm._s(_vm.letters)),
            ]),
            _vm._v(" "),
            _vm.backupIllustrationData
              ? _c(
                  "svg",
                  {
                    staticClass: "backupIllustration",
                    attrs: {
                      width: "43",
                      height: "26",
                      viewBox: "0 0 43 26",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("circle", {
                      attrs: {
                        cx: _vm.backupIllustrationData.x,
                        cy: _vm.backupIllustrationData.y,
                        r: _vm.backupIllustrationData.r,
                        fill: _vm.leColor.hex,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }